// extracted by mini-css-extract-plugin
export default {"postContainer":"Post_postContainer__1OdiT","tagsContainer":"Post_tagsContainer__uMLWH","imgContainer":"Post_imgContainer__lULBU","titleContainer":"Post_titleContainer__3guh2"};